import React, { useEffect, useState } from 'react';
import { PageLayout } from '../../components/PageLayout';
import { confirmNewsletterSignup } from 'src/services/newsletter.service';
import { useNavigate, useParams } from 'react-router-dom';
import LoadingSpinner from 'src/components/Loading/LoadingSpinner';

export const NewsletterCallbackSignupPage: React.FC = () => {
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string>('');
    const routeParams = useParams();
    const { email } = routeParams;

    useEffect(() => {
        if (email) {
            window.history.replaceState(null, '', '/');
            const confirmEmail = async () => {
                try {
                    const { data, error } = await confirmNewsletterSignup({ email });
                    if (error) {
                        setError('There was an error confirming your subscription.');
                    } else {
                        setMessage('Your subscription has been confirmed. Thank you!');
                    }
                } catch (err) {
                    setError('There was an error confirming your subscription.');
                } finally {
                    setIsLoading(false);
                }
            };
            confirmEmail();
        } else {
            setError('Invalid email confirmation link.');
            setIsLoading(false);
        }
    }, [email]);

    return (
        <PageLayout>
            <div className="newsletter-signup">
                {isLoading ? (
                    <LoadingSpinner />
                ) : (
                    <div>
                        <h2 className="stock-filings__title">
                            {error ? 'Error' : 'Newsletter Subscription Confirmation'}
                        </h2>
                        <p className="hero-banner__headline__3">
                            {error || message}
                        </p>
                    </div>
                )}
            </div>
        </PageLayout>
    );
};